import React from 'react'

function locateChild(children: React.ReactNode, tag: any) {
  let child: any = null
  React.Children.forEach(children, (c: any) => {
    if (c.type === tag) {
      child = child || c
    }
  })
  return child && child.props.children
}

function childByTagOr(defValue: string, children: React.ReactNode, tag: any) {
  const val = defValue || locateChild(children, tag)

  if (typeof val === 'function') {
    return val()
  }
  return val ?? <></>
}

export { childByTagOr, locateChild }
